/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_register_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a username`)
};

const zh_hans1_register_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一个用户名`)
};

const zh_hant1_register_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選擇一個使用者名稱`)
};

const fr_register_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez un nom d’utilisateur`)
};

const de_register_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzernamen wählen`)
};

const ja_register_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザー名を選択`)
};

const ko_register_username_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용자 이름을 선택하세요`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const register_username_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.register_username_placeholder(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("register_username_placeholder", locale)
	if (locale === "en") return en_register_username_placeholder(inputs)
	if (locale === "zh-Hans") return zh_hans1_register_username_placeholder(inputs)
	if (locale === "zh-Hant") return zh_hant1_register_username_placeholder(inputs)
	if (locale === "fr") return fr_register_username_placeholder(inputs)
	if (locale === "de") return de_register_username_placeholder(inputs)
	if (locale === "ja") return ja_register_username_placeholder(inputs)
	return ko_register_username_placeholder(inputs)
};